import React, { useEffect, useState } from "react";
import Select from "react-select";

import { useDispatch } from "react-redux";

import { Button } from "@wac-ui-dashboard/wac_component_library";
import { getBasicData } from "../../../store/slices/Transactions/transactionsSlice";
const TransactionsFilterForm = ({ formik, handleResetExtraFilters }) => {
  const dispatch = useDispatch();
  const [paymentOptions, setPayment] = useState([]);
  const [statusOptions, setStatus] = useState([]);
  

  useEffect(() => {
    dispatch(getBasicData())
      .unwrap()
      .then((result) => {
        setPayment(
          result.data.data.payment_gateway?.map((item) => ({
            label: item.name,
            value: item.status_id,
          }))
        );
        setStatus(
          result.data.data.status?.map((item) => ({
            label: item.name,
            value: item.status_id,
          }))
        );
      })
      .catch((err) => {});

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  return (
    <div>
      {/* Render form fields for the "Basic" tab */}

      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Payment Gateway
          </label>
          <Select
            name="paymentGateway"
            options={paymentOptions} // replace with your franchise options
            onChange={(selectedOption) =>
              formik.setFieldValue("paymentGateway", selectedOption)
            }
            className={`pro-input lg ${
              formik.errors.paymentGateway && formik.touched.paymentGateway && "error"
            }`}
            classNamePrefix={`pro-input`}
            onBlur={formik.handleBlur}
            value={formik.values.paymentGateway}
          />
          {formik.touched.paymentGateway && formik.errors.paymentGateway && (
            <div className="error">{formik.errors.paymentGateway}</div>
          )}
        </div>
      </div>
      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Status
          </label>
          <Select
            name="statusId"
            options={statusOptions} // replace with your franchise options
            onChange={(selectedOption) =>
              formik.setFieldValue("statusId", selectedOption)
            }
            className={`pro-input lg ${
              formik.errors.statusId && formik.touched.statusId && "error"
            }`}
            classNamePrefix={`pro-input`}
            onBlur={formik.handleBlur}
            value={formik.values.statusId}
          />
          {formik.touched.statusId && formik.errors.statusId && (
            <div className="error">{formik.errors.statusId}</div>
          )}
        </div>
      </div>
      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            Start Date
          </label>
          <input
            type="date"
            name="startDate"
            placeholder="Date of Birth"
            onChange={formik.handleChange}
            className={`pro-input lg ${
              formik.errors.startDate && formik.touched.startDate && "error"
            }`}
            onBlur={formik.handleBlur}
            value={formik.values.startDate}
          />
          {formik.touched.startDate && formik.errors.startDate && (
            <div className="error">{formik.errors.startDate}</div>
          )}
        </div>
      </div>

      <div className="col pro-mb-4">
        <div className="input-wrap">
          <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
            End Date
          </label>
          <input
            type="date"
            name="endDate"
            placeholder="Date of Birth"
            disabled={formik?.values?.startDate ? false : true}
            onChange={formik.handleChange}
            className={`pro-input lg ${
              formik.errors.endDate && formik.touched.endDate && "error"
            }`}
            onBlur={formik.handleBlur}
            value={formik.values.endDate}
          />
          {formik.touched.endDate && formik.errors.endDate && (
            <div className="error">{formik.errors.endDate}</div>
          )}
        </div>
      </div>

      <div
        className={`col-12 pro-d-flex pro-justify-end  "offcanvas-footer-sticky-btns"
        }`}
      >
        <Button
          className={"pro-btn-link lg pro-px-3"}
          onClick={handleResetExtraFilters}
        >
          Reset
        </Button>

        <Button
          className={`pro-btn-primary lg pro-ms-3 ${false ? "loading" : ""}`}
          type="submit"
          disabled={false}
          onClick={formik.handleSubmit}
        >
          Filter
        </Button>
      </div>
    </div>
  );
};

export default TransactionsFilterForm;
